module.exports = __webpack_public_path__ + "static/img/55.1930a32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/55.jpg
// module id = o/WI
// module chunks = 1